import { render, staticRenderFns } from "./AdminDataUpload.vue?vue&type=template&id=4664f584&v-if=isLoggedIn&"
import script from "./AdminDataUpload.vue?vue&type=script&lang=js&"
export * from "./AdminDataUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports